import { Icon } from "@/components/common/Icon";
import { cn } from "@/lib/utils";

// Generic feature / info card with a gold icon.
export const FeatureCard = ({ icon, title, text, className = "" }) => (
  <div
    className={cn(
      "rounded-2xl border border-stone-line bg-white p-6 md:p-8 transition-all duration-300 hover:-translate-y-1 hover:shadow-soft",
      className
    )}
  >
    {icon && (
      <div className="mb-5 flex h-12 w-12 items-center justify-center rounded-xl bg-gold/10 text-gold-dark">
        <Icon name={icon} size={22} />
      </div>
    )}
    <h3 className="font-serif text-xl md:text-2xl font-medium text-charcoal">{title}</h3>
    {text && (
      <p className="mt-2.5 text-base leading-relaxed font-light text-slatey">{text}</p>
    )}
  </div>
);

export default FeatureCard;
